import ICBack from "@/assets/common/ic_back_mobile.svg?react";
import ICFeedbackPicDel from "@/assets/common/ic_feedback_pic_del.svg?react";
import { useState } from "react";
import ICUploadImage from "@/assets/common/ic_upload_image.svg?react";
import { message, Upload, UploadFile, UploadProps } from "antd";
import "./index.less";
import { useNavigate } from "react-router-dom";
import FeedbackHandler from "@/bussiness/FeedbackHandler";

const validateFile = (file: File, withMessage = true) => {
  const isJpgOrPng =
    file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif"; 
  if (!isJpgOrPng) {
    if (withMessage) {
      message.warning('图片格式出错');
    }
    return false;
  }
  const isLt2M = file.size / 1024 / 1024 < 200;
  if (!isLt2M) {
    if (withMessage) {
      message.warning('图片不超过200M');
    }
    return false;
  }
  return true;
}

const getBase64 = (img: File) => {
  return new Promise((resolve, reject)=>{
    try {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result as string));
      reader.readAsDataURL(img);
    } catch (error) {
      reject(error);
    }
  })
};

const MobileFeedback = () => {
  const [content, setContent] = useState("");
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const navigate = useNavigate();

  const uploadProps: UploadProps = {
    accept: ".jpg, .jpeg, .png, .gif",
    showUploadList: false,
    multiple: true,
    fileList: fileList,
    async onChange(info) {
      const { fileList: newFileList } = info;

      const validFiles = newFileList.filter(file => 
        validateFile(file.originFileObj as File, false)
      ).slice(0, 4);

      const processedFiles = await Promise.all(
        validFiles.map(async (file) => {
          if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as File) as string;
          }
          return {
            ...file,
            url: file.url || file.preview
          };
        })
      );

      setFileList(processedFiles);
    },
    beforeUpload: (file) => {
      validateFile(file);
      return false;
    },
  };

  const onContentInput = (inputValue: string) => {
    setContent(inputValue);
  };

  const handleDeleteImage = (targetIndex: number) => {
    setFileList(prev => prev.filter((_, index) => index !== targetIndex));
  };

  const handleBack = () => {
    navigate("/home");
  }

  const commit = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    const mobile = queryParams.get("mobile") || "";
    const userId = queryParams.get("userId") || "";

    if (content.length === 0) {
      message.warning('请输入问题描述');
      return;
    }

    try {
      // 显示上传中状态
      message.loading('提交中，请稍等片刻', 0);

      const body = {
        logUrl: '',
        suggest: content,
        userId: userId,
        userPhone: mobile
      };

      if (fileList.length > 0) {
        const uploadResult = await FeedbackHandler.uploadLogHandle(fileList);
        if (uploadResult?.success) {
          body.logUrl = uploadResult.data || '';
        } else {
          message.error('图片上传失败');
          return;
        }
      }

      console.log('body = ', body);
      // 提交反馈
      await FeedbackHandler.commit(body);
      
      message.success('提交成功');
      handleBack();
    } catch (error) {
      console.error('Feedback submission failed:', error);
      message.error('提交失败，请重试');
    } finally {
      message.destroy(); // 清除loading消息
    }
  };


  return (
    <div className="h-full">
      <div className="pl-4 relative h-11 flex items-center justify-center text-4 font-500 text-#1F2533">
        问题反馈
        <ICBack className="absolute left-4" onClick={handleBack}/>
      </div>
      <div className="mt-5 ext-mx-tertiary text-3.5 lh-5.5 pl-4 font-500 mb-3">
        问题描述<span className="text-mx-error">*</span>
      </div>
      <div className="mx-4">
        <textarea
          autoFocus
          value={content}
          onChange={(e) => onContentInput(e.target.value)}
          className="content-textarea w-full h-60 rounded-2.5 px-4 py-3 border-0 bg-#FFFFFF text-size-3.5 focus:outline-none relative text-mx-secondary"
          placeholder="请简单描述问题现象"
        />
      </div>
      <div className="mt-4 px-4 feed-image-grid-container">
        {fileList.map((file, index) => (
          <div key={file.uid} className="relative h-20">
            <img 
              src={file.url || file.preview} 
              className="w-full h-full rounded-1 object-cover" 
              alt={file.name}
            />
            <ICFeedbackPicDel 
              className="size-3.5 absolute right--1.75 top--1.75" 
              onClick={() => handleDeleteImage(index)} 
            />
          </div>
        ))}
        
        {fileList.length < 4 && (
          <Upload {...uploadProps}>
            <div className="w-20 h-20 rounded-1 bg-#F7F8F9 flex flex-col items-center justify-center">
              <ICUploadImage />
              <span className="text-size-3 text-#999999">添加图片</span>
            </div>
          </Upload>
        )}
      </div>
        <div className="mt-6 mx-4 h-12.5 rd-3 bg-mx-primary text-#fff text-4 flex items-center justify-center" onClick={commit}>提  交</div>
    </div>
  );
};

export default MobileFeedback;
